export default __webpack_public_path__ + "static/media/domain-assets.550e1de6.svg";